// Section 9: Woodshed. 5 build points, 6 wood; +60 wood capacity; warmth efficiency 1.2x
// (warmth demand divided by 1.2). Constants: config.buildings.woodshed.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import {
  buildingEffectHook,
  capacityHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function woodshed(config: Config) {
  const c = config.buildings.woodshed;

  return defineBuilding({
    id: 'woodshed',
    label: 'Woodshed',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: { wood: c.woodCapacity },
    limit: { kind: 'none' },
    modifierTargets: ['capacity', 'demand', 'buildingEffect'],
    modifierKeys: { demand: ['warmth'] },
    modifiers: combineModifiers(
      buildingEffectHook('woodshed'),
      capacityHook('woodshed', { wood: c.woodCapacity }),
      (ctx, target) => {
        if (target.kind !== 'demand' || target.resource !== 'warmth') return [];
        const e = Math.min(1, effective(ctx, 'woodshed'));
        return e > 0
          ? [mod.mul('building:woodshed', 1 / (1 + (c.warmthEfficiency - 1) * e), 'dry firewood')]
          : [];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
